var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockContent = function SvgLockContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 159 124"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M79.795 121.745c33.46 0 60.543-26.832 60.543-59.938S113.255 1.965 79.795 1.965c-33.363 0-60.543 26.833-60.543 59.939s27.18 59.841 60.543 59.841Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M109.625 121.842c-9.224.289-20.312 0-28.162-.097-7.752.29-18.938.386-28.162.097 9.125-5.116 12.364-14.671 12.756-20.945h30.615c.687 6.177 3.925 15.829 12.953 20.945Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M139.258 20.98v78.855c0 2.027-1.57 3.475-3.336 3.475H27.592c-1.864 0-3.336-1.544-3.336-3.475V20.98c0-1.833 1.57-3.474 3.336-3.474h108.134c2.06.096 3.532 1.64 3.532 3.474Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M139.258 20.98v67.852H24.256V20.98c0-1.833 1.57-3.474 3.336-3.474h108.134c2.06.096 3.532 1.64 3.532 3.474Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    d: "M32.558 26.643h33.136v24.866H32.558zm41.025 0h55.226v10.102H73.583zm0 30.306h55.226V67.05H73.583zm0-16.318h55.226v4.662H73.583zm0 30.305h55.226v4.662H73.583zM32.558 56.949h33.136v24.866H32.558z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DDE8",
    d: "M81.56 98.58c1.57 0 2.847-1.158 2.847-2.798 0-1.545-1.178-2.8-2.846-2.8-1.57 0-2.846 1.16-2.846 2.8 0 1.544 1.178 2.798 2.846 2.798"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E6",
    stroke: "#A9B3BD",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M106.719 54.23c0 3.358-.569 6.437-1.848 9.376-2.841 7.278-8.951 12.876-16.483 15.396-2.557.84-5.257 1.26-8.1 1.26-14.635 0-26.43-11.617-26.43-26.033 0-14.415 11.795-26.031 26.43-26.031 14.637 0 26.431 11.757 26.431 26.032Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A9B3BD",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M86.21 50.944v-5.157c0-2.812-2.44-5.156-5.37-5.156-1.463 0-2.765.625-3.904 1.562-.976.938-1.627 2.188-1.627 3.75V51.1c-1.465.938-2.604 2.031-3.58 3.594a9.834 9.834 0 0 0-1.302 4.844c0 5.469 4.557 9.844 10.252 9.844s10.25-4.375 10.25-9.844c.164-3.75-1.79-6.875-4.718-8.594Zm-4.23 9.531v2.657c0 .312-.325.625-.65.625h-1.14c-.325 0-.65-.313-.65-.625v-2.656c-.977-.47-1.465-1.563-1.302-2.657.163-.937.976-1.719 1.953-1.875 1.627-.312 3.09.938 3.09 2.344 0 .937-.487 1.719-1.3 2.188zm1.628-10.625c-.977-.313-1.79-.469-2.93-.469-.975 0-1.952.156-2.928.469v-3.907c0-.78.325-1.562.813-2.03.489-.47 1.302-.782 2.116-.782 1.627 0 2.929 1.25 2.929 2.812z"
  })));
};
export default SvgLockContent;